import { Box, Typography } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import GlassCard from "../GlassCard";
import DemoLayout from "./DemoLayout";

export default function LockdownCYPage() {
  const isMobile = useMediaQuery("(max-width: 700px)");

  return (
    <DemoLayout title="LockdownCY">
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Box sx={{ width: "100%", maxWidth: { xs: "100%", md: "75%" } }}>
          <GlassCard>
            <Typography
              variant={isMobile ? "h6" : "h5"}
              color="secondary"
              sx={{ fontFamily: "Roboto", fontWeight: 700, mb: 2.5 }}
            >
              LockdownCY
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 3,
                alignItems: "flex-start",
              }}
            >
              <Box
                sx={{ flex: "0 0 auto", width: { xs: "100%", sm: "41.67%" } }}
              >
                <Box
                  component="iframe"
                  src="https://www.youtube.com/embed/D550HGF2x0U"
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                  title="LockdownCY demo video"
                  sx={{
                    width: "100%",
                    aspectRatio: "16/9",
                    border: "none",
                    borderRadius: "10px",
                    display: "block",
                  }}
                />
              </Box>
              <Box sx={{ flex: "1 1 0", minWidth: 0 }}>
                <Typography
                  variant="body1"
                  sx={{
                    color: "rgba(255,255,255,0.85)",
                    fontFamily: "RobotoLight",
                    fontWeight: 300,
                    lineHeight: 1.85,
                    mb: 2,
                  }}
                >
                  A React Native application serving as a guide to the most
                  recent movement instructions and restrictions issued by the
                  government of Cyprus during the COVID-19 pandemic. Available
                  for both iOS and Android via Expo.
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    color: "rgba(255,255,255,0.85)",
                    fontFamily: "RobotoLight",
                    fontWeight: 300,
                    lineHeight: 1.85,
                  }}
                >
                  Data was sourced directly from the{" "}
                  <a
                    href="https://www.pio.gov.cy"
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: "#FF83A8" }}
                  >
                    Cyprus Government Information Office
                  </a>{" "}
                  and stored in Firebase, enabling real-time updates without app
                  redeployment.
                </Typography>

                <Box sx={{ mt: 2.5 }}>
                  <Typography
                    variant="caption"
                    sx={{
                      color: "rgba(255,255,255,0.85)",
                      fontFamily: "RobotoLight",
                      fontWeight: 300,
                      textTransform: "uppercase",
                      letterSpacing: "1.4px",
                    }}
                  >
                    React Native Expo · JavaScript · Firebase
                  </Typography>
                </Box>
              </Box>
            </Box>
          </GlassCard>
        </Box>
      </Box>
    </DemoLayout>
  );
}
